// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3VArK","title":"Info_title__17U84","selects":"Info_selects__t_AWS","requiredAsterisk":"Info_requiredAsterisk__1o1rU"};